export enum TranslateScopes {
  Core = 'core',
  MainLayout = 'main-layout',
  MasterOperator = 'master-operator',
  ModelVersion = 'model-version',
  Navigations = 'navigations',
  Telemetry = 'telemetry',
  CtMap = 'ct-map',
  WlmSecurity = 'wlm-security',
  Workspaces = 'workspaces',
  Dashboard = 'dashboard',
  WlmNavigation = 'wlm-navigation',
}
